:host {
  --font-family: 'ArialMT', 'Arial', sans-serif;
  --font-size: var(--body-size);
  --dialog-title-font-size: var(--dialog-title-font-size);
  --blue-layout-400-primary: var(--blue-layout-400-primary);
  --blue-layout-300: var(--blue-layout-300-active);
  --body-size-xsmall: var(--body-size);
  --button-border-radius: 0px;
  --small-button-font-size: var(--body-size);
  --green-layout-100: var(--green-layout-100-primary-green);
  --red-alert-500-severe: var(--red-chart-600);
  --chart-300-icon-buttons: var(--chart-300-icon-buttons);
}

#window-wrapper {
  margin-top: -18px;
}

.header-buttons {
  margin-right: 5px;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
    max-height: 500px;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}
